import { Outlet } from "react-router-dom";
import AdminSidebar from "../components/admin/common/AdminSidebar";
import { useEffect, useState } from "react";
import AdminNavBar from "../components/admin/common/AdminNavBar";
import { Z_INDEX } from "../utils/constants";

const AdminLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Only for mobile drawer
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false); // Tablet/Desktop toggle

  // Device detection (mobile / tablet / desktop)
  const [device, setDevice] = useState(
    window.innerWidth < 768
      ? "mobile"
      : window.innerWidth < 1024
      ? "tablet"
      : "desktop"
  );

  // Update device type on resize
  useEffect(() => {
    const update = () => {
      const width = window.innerWidth;

      setDevice(width < 768 ? "mobile" : width < 1024 ? "tablet" : "desktop");
    };

    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  // Default sidebar behavior per device
  useEffect(() => {
    if (device === "mobile") {
      setIsSidebarOpen(false);
      setIsSidebarExpanded(false);
    }

    if (device === "tablet") {
      setIsSidebarOpen(false);
      setIsSidebarExpanded(false);
    }

    if (device === "desktop") {
      setIsSidebarExpanded(true);
    }
  }, [device]);

  const handleHamburgerClick = () => {
    if (device === "mobile") {
      setIsSidebarOpen((prev) => !prev);
    } else {
      setIsSidebarExpanded((prev) => !prev);
    }
  };

  return (
    <div className="relative font-quicksand h-screen overflow-hidden bg-gray-50">
      {/* Navbar */}
      <AdminNavBar
        handleHamburgerClick={handleHamburgerClick}
        isSidebarOpen={isSidebarOpen}
      />

      {/* Mobile Backdrop */}
      {device === "mobile" && isSidebarOpen && (
        <div
          style={{ zIndex: Z_INDEX.base }}
          onClick={() => setIsSidebarOpen(false)}
          className="fixed inset-0 bg-black/40 transition-opacity duration-200 ease-out"
        />
      )}

      {/* Sidebar */}
      <div
        style={{ zIndex: Z_INDEX.sidebar }}
        className={`
          fixed top-16 sm:top-18 md:top-20 bottom-0 
          transition-transform duration-300 ease-out transform

          ${
            device === "mobile"
              ? `right-0 w-60 bg-white shadow-xl 
                 ${isSidebarOpen ? "translate-x-0" : "translate-x-full"}`
              : `left-0 ${isSidebarExpanded ? "w-60" : "w-[5.3rem]"}`
          }
        `}
      >
        <AdminSidebar
          device={device}
          isSidebarOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
          isSidebarExpanded={isSidebarExpanded}
          setIsSidebarExpanded={setIsSidebarExpanded}
        />
      </div>

      {/* Main Content */}
      <main
        style={{ zIndex: Z_INDEX.base }}
        className={`
          pt-16 sm:pt-18 md:pt-20 h-full overflow-y-auto
          transition-[margin,opacity] duration-200 ease-out
          ${device === "mobile" && isSidebarOpen ? "opacity-95" : "opacity-100"}
          ${
            device !== "mobile"
              ? isSidebarExpanded
                ? "sm:ml-60"
                : "sm:ml-[5.3rem]"
              : ""
          }
        `}
      >
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;

// import { Outlet } from "react-router-dom";
// import AdminSidebar from "../components/admin/common/AdminSidebar";
// import { useState } from "react";
// import AdminNavBar from "../components/admin/common/AdminNavBar";
// import { Z_INDEX } from "../utils/constants";

// const AdminLayout = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);

//   const handleHamburgerClick = () => {
//     // console.log("clicked");
//     setIsSidebarOpen((prev) => !prev);
//   };
//   return (
//     <div className="flex font-quicksand h-screen overflow-hidden bg-gray-50">
//       <AdminNavBar handleHamburgerClick={handleHamburgerClick} />

//       {/* Sidebar */}
//       <div
//         style={{ zIndex: Z_INDEX.sidebar }}
//         className="fixed left-0 top-16 sm:top-18 md:top-20 bottom-0 "
//       >
//         <AdminSidebar
//           isSidebarOpen={isSidebarOpen}
//           onClose={() => setIsSidebarOpen(false)}
//           isSidebarExpanded={isSidebarExpanded}
//           setIsSidebarExpanded={setIsSidebarExpanded}
//         />
//       </div>

//       {/* Main content - Dynamic margin based on sidebar state */}
//       <main
//         style={{ zIndex: Z_INDEX.base }}
//         className={`flex-1 mt-16 sm:mt-18 md:mt-20 overflow-y-auto relative transition-all duration-300 ${
//           isSidebarExpanded ? "sm:ml-60" : "sm:ml-[5.3rem]"
//         }`}
//       >
//         <div className="">
//           <Outlet />
//         </div>
//       </main>
//     </div>
//   );
// };

// export default AdminLayout;
